import Component from '@glimmer/component';

import type { PreviewRow } from 'webapp/components/custom-query/setup/common/preview-table';

interface Args {
	model: PreviewRow;
	index: number;
}

export default class CustomQuerySetupCommonPreviewTableRowComponent extends Component<Args> {
	get shownIndex(): number {
		return this.args.index + 1;
	}
	<template>
		<tr class="table-row">
			<td>{{this.shownIndex}}</td>
			{{#each @model.data key="@index" as |cell|}}
				<td>
					{{#if cell.transformed}}
						{{cell.transformed}}
						<span class="tranformedRow">{{cell.current}}</span>
					{{else}}
						{{cell.current}}
					{{/if}}
				</td>
			{{/each}}
		</tr>
	</template>
}
